import logoPC from "../../assets/logo.png"
import logoBP from "../../assets/logoBP.png"
import logoCE from "../../assets/logoCE.png"
import {format} from 'date-fns'
import 'react-day-picker/dist/style.css'
import React, {useRef, useState} from "react";
import DayPicking from "../Form/DayPicking";
import fr from "date-fns/locale/fr"
import ReactSelectAgences from "../Form/ReactSelectAgences";
import axios from "axios"
import Popin from "../Popin/Popin";
import ReactSelectTime from "../Form/ReactSelectTime";
import Footer from "../Layout/Footer";
import {getApiUrl} from "../../utils/getApiUrl";

function AppClient(etablissement) {

    const [checkbox, setCheckBox] = useState(false)
    const [showDate, setShowDate] = useState(false)
    const [selected, setSelected] = useState()
    const [message, setMessage] = useState("")
    const [errorFormApi, setErrorFormApi] = useState(false)
    const [popin, setPopin] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const [classNamePrenomInput, setClassNamePrenomInput] = useState("")
    const [classNameNomInput, setClassNameNomInput] = useState("")
    const [classNameMailInput, setClassNameMailInput] = useState("")
    const [classNameTelInput, setClassNameTelInput] = useState("")
    const [classNameDateInput, setClassNameDateInput] = useState("")
    const [classNameDayPicker, setClassNameDayPicker] = useState("")

    const [errMessageNomInput, setErrMessageNomInput] = useState("")
    const [errMessagePrenomInput, setErrMessagePrenomInput] = useState("")
    const [errMessageMailInput, setErrMessageMailInput] = useState("")
    const [errMessageTelInput, setErrMessageTelInput] = useState("")

    let date;
    if (selected) {
        date = "Le " + format(selected, 'EEEEEEEEE' + " dd" + " MMMM" + " yyyy", {locale: fr})
    }

    console.log("etablise", etablissement)
    // DATA A ENVOYER À L'API
    // ref
    const refPrenom = useRef("")
    const refNom = useRef("")
    const refEmail = useRef("")
    const refTel = useRef("")
    const refDay = useRef("")
    const refTime = useRef("")
    let time;
    const refAgence = useRef("")
    const refCheckbox = useRef()
    // console.log("refCheckbox", refCheckbox.current)

    // ENVOI DU FORMULAIRE
    const handleCheckbox = (e) => {
        // console.log(e)
        if (e.target.checked) {
            setCheckBox(true)
        } else
            setCheckBox(false)
    }
    const handleForm = (e) => {
        setIsLoading(true)
        setMessage("")
        setErrorFormApi(false)
        e.preventDefault();
        let time = document.getElementsByClassName("select-search-input")
        time = time[0].value
        console.log(refAgence.current.state.value)
        if (
            refPrenom.current.value === "" ||
            refNom.current.value === "" ||
            refEmail.current.value === "" ||
            refTel.current.value === "" ||
            refDay.current.value === undefined ||
            time === "" ||
            refAgence.current.state.value === null
        ) {
            setIsLoading(false)
            setMessage("Vous devez compléter tous les champs pour soumettre votre demande.")
        } else if (
            (errMessagePrenomInput ||
                errMessageNomInput ||
                errMessageMailInput ||
                errMessageTelInput) !== ""
        ) {
            setIsLoading(false)
            setMessage("Votre formulaire n'est pas conforme, veuillez vérifier les informations saisies.")
        } else if (!checkbox) {
            setIsLoading(false)
            setMessage("Vous devez accepter le partage de vos données pour soumettre votre formulaire.")
        } else {
            let data = new FormData();
            const agence = refAgence.current.state.value
            data.append('prenom', refPrenom.current.value)
            data.append('nom', refNom.current.value)
            data.append('email', refEmail.current.value)
            data.append('tel', refTel.current.value)
            data.append('day', refDay.current.value)
            data.append('time', time)
            data.append('agence', JSON.stringify(agence))
            data.append('banque', JSON.stringify(etablissement))

            axios.post(`${getApiUrl()}/createBPCE/index.php`,
                data,
                {withCredentials: true}
            )
                .then((r) => {
                    setIsLoading(false)
                    setPopin(true)
                    setErrorFormApi(false)
                })
                .catch((err) => {
                    setPopin(false)
                    setIsLoading(false)
                    setErrorFormApi(true)
                });
        }
    }


    return (
        <div className="App">

            <header>
                <div className={"logo prevandcare"}>
                    <a href={"https://www.prevandcare.com"}
                       target="_blank" rel="noreferrer"><img src={logoPC}/></a>
                </div>
                <div className={"logo text"}><p>en partenariat avec</p></div>
                <div className={"logo bpce"}>
                    {etablissement.etablissement === "bp"
                        ? <img src={logoBP} alt={"logo banque populaire"}/>
                        : <img src={logoCE} alt={"logo caisse d'épargne"}/>
                    }
                </div>
            </header>

            <main>
                <div className={"intro"}>
                    <h1>
                        Demande de <div className={"nauticus"}>contact</div>
                    </h1>
                    <p>
                        Lorsque l’organisation des soins de votre proche fragilisé par l’âge, la maladie ou le handicap
                        vous submerge, les Care Managers Prev&Care sont à vos côtés pour mettre en place les meilleures
                        solutions.
                        <br/> Ce formulaire vous permet d’être rappelé gratuitement par l’un des assistants personnels
                        Prev&Care.</p>
                </div>

                <div className={"form client"}>
                    <h2>Vos coordonnées</h2>
                    <form
                        id={"form"}
                        onSubmit={handleForm}>
                        {/*<FilterAgency refAgence={refAgence}/>*/}
                        <div className={"input-container small"}>
                            <input
                                required
                                type={"text"}
                                ref={refPrenom}
                                onFocus={() => setClassNamePrenomInput("active")}
                                onChange={() => {
                                    if (/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u.test(refPrenom.current.value))
                                        setErrMessagePrenomInput("")
                                    else setErrMessagePrenomInput("Le format de votre prénom est incorrect")
                                }}/>
                            <div className={"placeholder"}>
                                <p className={classNamePrenomInput}>Prénom *</p>
                            </div>
                            <span className={"errMessage"}>{errMessagePrenomInput}</span>
                        </div>
                        <div className={"input-container small"}>
                            <input
                                required
                                type={"text"}
                                ref={refNom}
                                onFocus={() => setClassNameNomInput("active")}
                                onChange={() => {
                                    if (/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u.test(refNom.current.value))
                                        setErrMessageNomInput("")
                                    else setErrMessageNomInput("Le format de votre nom est incorrect")
                                }}/>
                            <div className={"placeholder"}>
                                <p className={classNameNomInput}>Nom *</p>
                            </div>
                            <span className={"errMessage"}>{errMessageNomInput}</span>
                        </div>
                        <div className={"input-container"}>
                            <input
                                required
                                type={"email"}
                                ref={refEmail}
                                onFocus={() => setClassNameMailInput("active")}
                                onChange={() => {
                                    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(refEmail.current.value))
                                        setErrMessageMailInput("")
                                    else setErrMessageMailInput("Votre adresse mail doit être au format : xxxxx@xxxx.xx")
                                }}
                            />
                            <div className={"placeholder"}>
                                <p className={classNameMailInput}>Adresse e-mail *</p>
                            </div>
                            <span className={"errMessage"}>{errMessageMailInput}</span>
                        </div>
                        <div className={`input-container ${classNameTelInput}`}>
                            <input
                                required
                                type={"tel"}
                                ref={refTel}
                                onFocus={() => {
                                    setClassNameTelInput("active")
                                    console.log("clsnmtelinput", classNameTelInput)
                                }}
                                onChange={() => {
                                    if (/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/.test(refTel.current.value))
                                        setErrMessageTelInput("")
                                    else setErrMessageTelInput("Votre numéro de téléphone doit contenir au minimum 10 chiffres")
                                }}/>
                            <div className={"placeholder"}>
                                <p className={classNameTelInput}>Numéro de téléphone *</p>
                            </div>
                            <span className={"errMessage"}>{errMessageTelInput}</span>
                        </div>
                        <div className={`input-container ${classNameDateInput} dayContainer`}>
                            <input
                                onFocus={(() => {
                                    setClassNameDateInput("active")
                                    setShowDate(true);
                                    setClassNameDayPicker("behind")
                                })}
                                value={selected && date}
                                ref={refDay}
                                onBlur={() => {
                                    setTimeout(() => {
                                        setShowDate(false)
                                    }, 999999)
                                }}
                            />
                            <div className={"placeholder"}>
                                <p className={classNameDateInput}>Choisissez une date *</p>
                            </div>
                            <div id={"picker-container"}>
                                {showDate &&
                                    <DayPicking
                                        selected={selected}
                                        setSelected={setSelected}
                                        date={date}
                                        setShowDate={setShowDate}/>
                                }
                            </div>
                        </div>
                        <ReactSelectTime refTime={refTime} refAgence={refAgence}/>
                        <ReactSelectAgences refAgence={refAgence} etablissement={etablissement}/>
                    </form>
                </div>

                <div className={"shareInfos"}>
                    <input
                        type="checkbox"
                        className={"shareInfos-checkbox"}
                        onChange={handleCheckbox}
                        name="checkbox"
                        ref={refCheckbox}
                    />
                    <p className={"shareInfos-p"}>
                        J’accepte que mes informations soient recueillies par Prev&Care, partenaire
                        de {etablissement.etablissement === "bp"
                        ? " la Banque Populaire"
                        : " la Caisse d'Epargne"
                    }. En sa qualité de Responsable de Traitement, Prev&Care collecte et
                        traite ces données afin de vous contacter et vous adresser les informations sollicitées. Pour en
                        savoir plus sur la gestion de vos données et vos droits, vous pouvez consulter notre <a
                        href={`https://www.prevandcare.com/legals-rgpd.php`} target={"_blank"} rel="noreferrer">Politique
                        de
                        confidentialité</a>. *</p>
                </div>
                {errorFormApi &&
                    <p className={"errorMessage"}>Il y a eu une erreur lors de l'envoi de votre formulaire. Vérifiez
                        votre connexion internet et
                        réessayez. Si le problème persiste, vous pouvez nous contacter <a
                            href={"https://www.prevandcare.com/aidants-familiaux-care-manager-contact.php"}
                            target="_blank"
                            style={{
                                textDecoration: "none",
                                color: "red",
                                fontWeight: 800,
                                textDecorationLine: "underline",
                            }} rel="noreferrer">ici</a> par téléphone ou par
                        mail.</p>
                }

                {isLoading && <div className={"loadingSpinner"}/>}
                <p className={"footMessage"} style={{marginTop: "2vh"}}>* Champ obligatoire.</p>
                <p className={"errorMessage"}>{message}</p>
                {popin && <Popin prenom={refPrenom} email={refEmail}/>}
                <div className={"button-block"}>
                    <button
                        className={checkbox ? "active" : "inactive"}
                        type={"submit"}
                        form={"form"}
                        onClick={((e) => {
                                handleForm(e);
                                // setMessage("")
                            }
                        )
                        }
                    >
                        Envoyer la demande de rappel
                    </button>

                </div>
            </main>

            <Footer/>

        </div>
    );
}

export default AppClient;
